export enum ACCESS {
    OWNER = 'Owner',
    GroupManager = 'Group Manager',
    GroupReviewer = 'Group reviewer',
    ADMIN = 'Admin',
    ADVISOR = 'Advisor',
    MANAGER = 'Manager',
    ASSISTANT = 'Assistant',
    InternalReviewerExtended = 'Internal Reviewer Extended',
    InternalReviewer = 'Internal Reviewer',
    REVIEWER = 'Reviewer',
    ArApSupervisor = 'AR/AP Supervisor',
    ArApManager= 'AR/AP Manager',
    ArApAssistant= 'AR/AP Assistant',
    BillApprover = 'Bills Approver',
    BillsAssistant = 'Bills Assistant',
    Cardholder = 'Cardholder',
    CategoryManager = 'Category Manager',
    CategoryReviewer = 'Category Reviewer'
}

export const todayOnlyRoles: string[] = [
    ACCESS.CategoryManager.toString().toLowerCase(),
    ACCESS.CategoryReviewer.toString().toLowerCase()
];

export const todayRoles: string[] = [
    ACCESS.OWNER.toString().toLowerCase(),
    ACCESS.ADMIN.toString().toLowerCase(),
    ACCESS.ADVISOR.toString().toLowerCase(),
    ACCESS.MANAGER.toString().toLowerCase(),
    ACCESS.GroupManager.toString().toLowerCase()
];

export const interCompanyMainGroupRoles: string[] = [
    ACCESS.OWNER.toString().toLowerCase(),
    ACCESS.GroupManager.toString().toLowerCase()
];

export const interCompanyInvitedCompaniesRoles: string[] = [
    ACCESS.ADMIN.toString().toLowerCase()
];

export const integrationDependsCheckRoles: string[] = [
    ACCESS.OWNER.toString().toLowerCase(),
    ACCESS.ADMIN.toString().toLowerCase(),
    ACCESS.ADVISOR.toString().toLowerCase(),
    ACCESS.MANAGER.toString().toLowerCase(),
    ACCESS.GroupManager.toString().toLowerCase(),
    ACCESS.ASSISTANT.toString().toLowerCase(),
    ACCESS.ArApSupervisor.toString().toLowerCase(),
    ACCESS.ArApManager.toString().toLowerCase(),
    ACCESS.ArApAssistant.toString().toLowerCase(),
    ACCESS.BillsAssistant.toString().toLowerCase(),
    ACCESS.BillApprover.toString().toLowerCase(),
    ACCESS.Cardholder.toString().toLowerCase(),
    ACCESS.CategoryManager.toString().toLowerCase()
];

export const arApRoles: string[] = [
    ACCESS.ArApAssistant.toString().toLowerCase(),
    ACCESS.ArApManager.toString().toLowerCase(),
    ACCESS.ArApSupervisor.toString().toLowerCase(),
    ACCESS.BillsAssistant.toString().toLowerCase(),
    ACCESS.BillApprover.toString().toLowerCase()
];

export const progressRoles: string[] = [
    ACCESS.OWNER.toString().toLowerCase(),
    ACCESS.ADMIN.toString().toLowerCase(),
    ACCESS.ADVISOR.toString().toLowerCase(),
    ACCESS.MANAGER.toString().toLowerCase(),
    ACCESS.GroupManager.toString().toLowerCase()
];